'use client';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import Image from 'next/image';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';

import styles from './index.module.scss';

import { HomeImages } from '@/data/first-page-images';

export default function Carousel() {
  return (
    <div className={styles.carouselCont}>
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        loop
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        speed={1000}
        slidesPerView={'auto'}
        modules={[Autoplay]}
      >
        {HomeImages.map((image, index) => (
          <SwiperSlide key={index}>
            <div className={styles.swiper}>
              <Image
                className={styles.img}
                src={image.src}
                alt={image.alt}
                fill
                sizes="25vw, 30vw, 45vw, 50vw, 60vw, 100vw"
                loading="lazy"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
